import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';

import SidebarLayout from '../user-panel/layouts/SidebarLayout';
import BaseLayout from '../user-panel/layouts/BaseLayout';

import SuspenseLoader from '../user-panel/components/SuspenseLoader';
import VisitHome from '../visit-home';
import { element } from 'prop-types';
import VisitLogin from '../visit-login';
import VisitRegister from '../visit-register';

const Loader = (Component) => (props) =>
(
  <Suspense fallback={<SuspenseLoader />}>
    <Component {...props} />
  </Suspense>
);

// Pages

const Overview = Loader(lazy(() => import('../user-panel/content/overview')));

// Dashboards

const Crypto = Loader(lazy(() => import('../user-panel/content/dashboards/Crypto')));

// Applications

const Messenger = Loader(
  lazy(() => import('../user-panel/content/applications/Messenger'))
);
const Transactions = Loader(
  lazy(() => import('../user-panel/content/applications/Transactions'))
);
const UserProfile = Loader(
  lazy(() => import('../user-panel/content/applications/Users/profile'))
);
const UserSettings = Loader(
  lazy(() => import('../user-panel/content/applications/Users/settings'))
);

// Components

const Buttons = Loader(
  lazy(() => import('../user-panel/content/pages/Components/Buttons'))
);
const Modals = Loader(
  lazy(() => import('../user-panel/content/pages/Components/Modals'))
);
const Accordions = Loader(
  lazy(() => import('../user-panel/content/pages/Components/Accordions'))
);
const Tabs = Loader(lazy(() => import('../user-panel/content/pages/Components/Tabs')));
const Badges = Loader(
  lazy(() => import('../user-panel/content/pages/Components/Badges'))
);
const Tooltips = Loader(
  lazy(() => import('../user-panel/content/pages/Components/Tooltips'))
);
const Avatars = Loader(
  lazy(() => import('../user-panel/content/pages/Components/Avatars'))
);
const Cards = Loader(lazy(() => import('../user-panel/content/pages/Components/Cards')));
const Forms = Loader(lazy(() => import('../user-panel/content/pages/Components/Forms')));

// Status

const Status404 = Loader(
  lazy(() => import('../user-panel/content/pages/Status/Status404'))
);
const Status500 = Loader(
  lazy(() => import('../user-panel/content/pages/Status/Status500'))
);
const StatusComingSoon = Loader(
  lazy(() => import('../user-panel/content/pages/Status/ComingSoon'))
);
const StatusMaintenance = Loader(
  lazy(() => import('../user-panel/content/pages/Status/Maintenance'))
);

const routes = [
  
  { path: '/login', element: <VisitLogin /> },
  { path: '/register', element: <VisitRegister /> },
  {
    path: 'dashboards',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="crypto" replace />
      },
      {
        path: 'crypto',
        element: <Crypto />
      },
      {
        path: 'messenger',
        element: <Messenger />
      }
    ]
  },
  {
    path: 'management',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="transactions" replace />
      },
      {
        path: 'transactions',
        element: <Transactions />
      },
      {
        path: 'profile',
        children: [
          {
            path: '',
            element: <Navigate to="details" replace />
          },
          {
            path: 'details',
            element: <UserProfile />
          },
          {
            path: 'settings',
            element: <UserSettings />
          }
        ]
      }
    ]
  },
  {
    path: '/components',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="buttons" replace />
      },
      {
        path: 'buttons',
        element: <Buttons />
      },
      {
        path: 'modals',
        element: <Modals />
      },
      {
        path: 'accordions',
        element: <Accordions />
      },
      {
        path: 'tabs',
        element: <Tabs />
      },
      {
        path: 'badges',
        element: <Badges />
      },
      {
        path: 'tooltips',
        element: <Tooltips />
      },
      {
        path: 'avatars',
        element: <Avatars />
      },
      {
        path: 'cards',
        element: <Cards />
      },
      {
        path: 'forms',
        element: <Forms />
      }
    ]
  }
];

export default routes;
